<template>
  <div id="footer">
    <div class="footer-content">
      <h3>Michael McFarland</h3>
      <p>Denver, CO</p>
      <p>Have Project, Will Travel</p>

      <a class="mcf-email" href="mailto:mcfarlandweb@gmail.com"
        >mcfarlandweb@gmail.com</a
      >
      <div class="footer-icons-cont">
        <a
          href="https://www.linkedin.com/in/michael-d-mcfarland/"
          target="_blank"
        >
          <img src="../assets/images/tech-icons/linkedin-brands.svg" />
        </a>

        <a href="https://github.com/mcfarland422/" target="_blank">
          <img src="../assets/images/tech-icons/github-brands.svg" />
        </a>
        <a href="https://www.instagram.com/mcfarland422/" target="_blank">
          <img src="../assets/images/tech-icons/instagram-brands.svg" />
        </a>
        <a href="https://www.instagram.com/mcfarland422/" target="_blank">
          <img src="../assets/images/tech-icons/twitter-brands.svg" />
        </a>
        <a
          href="http://www.imdb.com/name/nm5467446/?ref_=fn_al_nm_1"
          target="_blank"
        >
          <img src="../assets/images/tech-icons/imdb-brands.svg" />
        </a>
      </div>
      <div class="footer-bottom">
        <v-divider></v-divider>
        <p className="text-muted">
          &copy;{{ new Date().getFullYear() }} <strong>McFarland Web</strong>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss">
@import "../scss/styles.scss";

#footer {
  text-align: center;

  .footer-content {
    margin-top: 1rem;
    background: $white;
    z-index: 20;
    padding: 0 1rem;
    h3 {
      color: $mcf-blue;
      text-shadow: #000 0 2px 3px;
      font-size: 1.5rem;
      font-family: "Montserrat", sans-serif;
      @include md {
        font-size: 2rem;
      }
    }
    p {
      font-size: 1rem;
      margin-bottom: 0.5rem;
      &:first-of-type {
        margin-top: 0.6rem;
      }
      @include md {
        font-size: 1.5rem;
      }
    }
    a {
      text-decoration: none;
      font-size: 1.2rem;
      display: inline-block;
    }
    .footer-icons-cont {
      display: flex;
      width: 100%;
      max-width: 250px;
      margin: 2rem auto;
      justify-content: space-between;
      @include md {
        max-width: 375px;
      }
      img {
        width: 2.2rem;
        display: inline-block;
        @include md {
          width: 3rem;
        }
      }
    }
  }
  .footer-bottom {
    max-width: 1080px;
    margin: auto;
    color: #777;
    margin-bottom: 1rem;
    p {
      font-size: 1rem;
      font-family: "Montserrat", sans-serif;
      margin: 1rem 0 2rem !important;
    }
  }
  .mcf-email {
    @include md {
      font-size: 1.5rem !important;
    }
  }
}
</style>